'use client';
import React from 'react';
import LegalPageShell from '@/components/LegalPageShell';
import SecurityContent from './components/SecurityContent';

export default function SecurityPage() {
  return (
    <LegalPageShell>
      <SecurityContent />
    </LegalPageShell>
  );
}
